/*
 * @Author: Smart Chow
 * @Date: 2022-01-05 21:32:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-06 10:27:45
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_store/index.js
 */

import { requestApi } from '@/frameworks/http/services'
const state = {}

const mutations = {}

const actions = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
